/**
  * @file
  * Attach behaviors for the Resources menu.
  */

!((document, Drupal, $) => {
  'use strict';

  /**
   * Setup and attach the Menu Toggle.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.resourcesMenu = {

    attach: function (context) {
      const $resourceList = $('.resources__btn', context);
      const $resourceArrow = $('.resources__arrow', context);
      const $resourceMenu = $('.resources__links', context);
      const $resourceGroup = $('.resources__links-list', context);
      const $resourceContain = $('.resources__container', context);

      $resourceList.on('click', function () {
        $(this).toggleClass('js-resource-menu-open');
        $resourceMenu.toggleClass('js-resource-menu-open');
        $resourceContain.toggleClass('js-resource-menu-open');
        $resourceArrow.toggleClass('js-rotate');
        if ($(this).hasClass('js-resource-menu-open')) {
          $(this).attr('aria-expanded', 'true');
          $resourceGroup.attr('aria-hidden', 'false');
        }

        else {
          $(this).attr('aria-expanded', 'false');
          $resourceGroup.attr('aria-hidden', 'true');
        }
      });
    }
  };
})(document, Drupal, jQuery);
